import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import { Button } from "@/components/ui/button/Button";

interface ChunkLoadErrorFallbackProps {
  variant?: "page" | "window";
  "data-testid"?: string;
}

/**
 * Shown when a lazy route chunk failed to load and an automatic reload did not recover.
 */
export function ChunkLoadErrorFallback({
  variant = "page",
  "data-testid": testId = "chunk-load-error-fallback",
}: ChunkLoadErrorFallbackProps) {
  const isWindow = variant === "window";

  return (
    <div
      className={
        isWindow
          ? "flex flex-col items-center justify-center h-full min-h-[200px] p-8 text-center"
          : "pt-16 p-4 container mx-auto"
      }
      data-testid={testId}
    >
      <h1
        className={`font-semibold text-gray-900 dark:text-gray-100 ${
          isWindow ? "text-lg" : "text-2xl"
        }`}
      >
        Update required
      </h1>
      <p className="mt-2 text-gray-700 dark:text-gray-300 max-w-md">
        A new version of the app is available. Refresh to load the latest build
        and continue.
      </p>
      <div className="mt-6">
        <Button
          type="button"
          color="indigo"
          onClick={() => window.location.reload()}
          data-testid="chunk-load-refresh-button"
        >
          <FontAwesomeIcon icon={faArrowsRotate} className="w-4 h-4" />
          Refresh
        </Button>
      </div>
    </div>
  );
}
